import { createSvgIcon } from "@mui/material";

export const CloudDownloadIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46" fill="currentColor">
        <g>
            <path d="M202.05,124.93c-5.4-28.07-30.13-49.35-59.76-49.35c-23.75,0-44.35,13.68-54.38,33.57
                c-24.81,2.66-44.19,23.72-44.19,49.22c0,27.3,22.21,49.51,49.51,49.51h104.93c22.92,0,41.57-18.65,41.57-41.57
                C239.73,144.71,223.16,126.9,202.05,124.93z M98.65,126.06c0.86-3.39,5.11-18.68,20.18-27.71c1.39-0.83,11.46-6.04,23.47-6.04
                c24.74,0,46.25,23.66,46.25,48.4l9.62,0.04v0c13.95,0,25.33,11.23,25.57,25.13c0.24,14.3-11.84,26.01-26.15,26.01H93.24
                c-19.09-1.44-33.37-16.73-33.51-33.51c-0.03-3.83,0.68-7.61,2.02-11.18c4.62-12.25,16.43-20.29,29.51-20.83
                C93.72,126.27,96.19,126.16,98.65,126.06z"/>
            <polygon points="153.86,149.85 153.86,125.25 129.86,125.25 129.86,149.85 108.73,149.85 141.86,182.98 174.99,149.85"/>
        </g>
    </svg>,
    'CloudDownloadIcon'
)
